import styled from 'styled-components';
import Share from 'ggApp/shared/icons/Share';

export const ShareButton = styled.button`
  cursor:pointer;
`;

export const ShareIcon = styled(Share)`
  & path {
      opacity: .25;
  }
  &:hover path {
      opacity: 1;
  }
`;
